import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

interface Props {
  questionGroup: QuestionGroup
  reviewIsNotActive: boolean
}

export default function EditableUntilBanner({ questionGroup, reviewIsNotActive }: Props) {
  const editableUntil = questionGroup.attributes.editable_until

  const description = () => {
    const answerNotEditable =
      (editableUntil && moment().isAfter(editableUntil)) || reviewIsNotActive

    if (answerNotEditable) {
      return i18n.t('surveys.review.answer.editable_until_banner.answer_not_editable')
    } else if (!answerNotEditable && editableUntil) {
      return i18n.t('surveys.review.answer.editable_until_banner.editable_until', {
        date: moment(editableUntil).format('L'),
      })
    } else {
      return i18n.t('surveys.review.answer.editable_until_banner.generic_message')
    }
  }

  return (
    <Box
      gap="s12"
      flexDirection="row"
      padding="s12"
      alignItems="center"
      justifyContent="center"
      height="s48"
      background="champagne400"
    >
      <Icon.Medium icon="info-circle-line" color="grey800" />
      <Text.Normal size="300" weight="medium" color="grey800">
        {description()}
      </Text.Normal>
    </Box>
  )
}
